var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticClass: "wl-select input-with-select",
      attrs: {
        multiple: _vm.multi,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        "collapse-tags": _vm.collapseTags,
        clearable: _vm.clearable,
        filterable: _vm.filterable,
      },
      on: { change: _vm.onValueChange },
      model: {
        value: _vm.myValue,
        callback: function ($$v) {
          _vm.myValue = $$v
        },
        expression: "myValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.value,
        attrs: {
          label: _vm.i18n ? _vm.$t(item.label) : item.label,
          value: item.value,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }